export const getBalanceError = (state) => state.balanceError;
export const getBalanceSuccess = (state) => state.balanceSuccess;
export const getIsBalanceLoading = (state) => state.isBalanceLoading;
export const getBalanceItem = (state) => state.balanceItem;
export const getSelectedEducation = (state) => state.selectedEducation;
export default {
    getBalanceError,
    getBalanceSuccess,
    getIsBalanceLoading,
    getBalanceItem,
    getSelectedEducation,
};
